// extracted by mini-css-extract-plugin
module.exports = {"common":"markdown_common__MyYa4","inheritFonts":"markdown_inheritFonts__aOOs4"};